<template>
  <div id="welcome" class="d-flex" style="height: 100%">
    <welcome-message
      v-if="show"
      class="align-center justify-center"
    ></welcome-message>
  </div>
</template>

<script>
import WelcomeMessage from '@/components/WelcomeMessage.vue'

export default {
  name: 'StartView',

  components: {
    WelcomeMessage,
  },
  data: () => ({ show: true }),
}
</script>

<style>
#welcome {
  background-image: url('../../public/welcome.png');
  background-position: top;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
